import { abs } from "../../../core/util/math/Math"
import sumArray from "../../../ldsh/sumArray"
import type { NeighborWeights } from "./NeighborWeights.type"

const EXP = 7

/**
 * Computes spatial weights for a normalized point (x, y) on a square tile.
 * nx and ny are already normalized so x ∈ [‑halfSize, halfSize].
 */
export default function createNeighborWeightsV1(
  nx: number,
  ny: number,
): Readonly<NeighborWeights> {
  const adx = abs(nx)
  const ady = abs(ny)

  // if (adx > 1 || ady > 1) {
  //   console.log('adx', adx, 'ady', ady)
  //   // throw new Unexpected(`adxy > 1`)
  // }

  // cubic fall‑off towards tile centre
  const wx = 1 - (adx ** EXP)
  const wy = 1 - (ady ** EXP)

  const base = wx * wy

  // cardinal neighbours
  const n = (ny < 0 ? 1 - wy : 0) * wx
  const s = (ny > 0 ? 1 - wy : 0) * wx
  const e = (nx > 0 ? 1 - wx : 0) * wy
  const w = (nx < 0 ? 1 - wx : 0) * wy

  // diagonals
  const ne = (nx > 0 && ny < 0) ? (1 - wx) * (1 - wy) : 0
  const nw = (nx < 0 && ny < 0) ? (1 - wx) * (1 - wy) : 0
  const se = (nx > 0 && ny > 0) ? (1 - wx) * (1 - wy) : 0
  const sw = (nx < 0 && ny > 0) ? (1 - wx) * (1 - wy) : 0

  const list = [n, ne, e, se, s, sw, w, nw]
  const total = base + sumArray(list)

  return { base, list, total }
}
